import React, { Component } from "react";
import questions from "../data/questionbank";
import results from "../data/result"; // Import the results file
import QuestionBox from "./QuestionBox";

class TestComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      participantName: "",
      participantClass: "", // Added class field
      participantSection: "", // Added section field
      participantRoll: "", // Added roll field
      quizSession: [],
      noOfQuesAttained: 0,
      noOfQuesCorrect: 0,
      questionsAnswered: new Set(),
      timeLeft: 120, // 2 minutes in seconds
      isQuizStarted: false,
      isQuizEnded: false,
      timerInterval: null,
    };

    this.updateStatus = this.updateStatus.bind(this);
    this.startQuiz = this.startQuiz.bind(this);
    this.resetQuiz = this.resetQuiz.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this); // Added submit handler
  }

  getQuestions = () => {
    questions().then((questions) => {
      console.log(questions);
      this.setState({ quizSession: questions });
    });
  };

  updateStatus(ansIsCorrect, questionId) {
    // Prevent double-counting if user clicks multiple answers
    if (!this.state.questionsAnswered.has(questionId)) {
      const newQuestionsAnswered = new Set(this.state.questionsAnswered);
      newQuestionsAnswered.add(questionId);

      this.setState((prevState) => ({
        noOfQuesAttained: prevState.noOfQuesAttained + 1,
        noOfQuesCorrect: ansIsCorrect
          ? prevState.noOfQuesCorrect + 1
          : prevState.noOfQuesCorrect,
        questionsAnswered: newQuestionsAnswered,
      }));
    }
  }

  // Submit function to save results and end quiz
  handleSubmit() {
    // Stop the timer
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
    }

    // Save results
    this.saveResults();

    // End the quiz
    this.setState({
      isQuizEnded: true,
      timerInterval: null,
    });
  }

  // Function to save results to the result.js file
  saveResults() {
    const {
      participantName,
      participantClass,
      participantSection,
      participantRoll,
      noOfQuesAttained,
      noOfQuesCorrect,
      quizSession,
    } = this.state;

    const resultData = {
      name: participantName,
      class: participantClass, // Added class field
      section: participantSection,
      roll: participantRoll,
      score: noOfQuesCorrect,
      totalQuestions: quizSession.length,
      questionsAttempted: noOfQuesAttained,
      timestamp: new Date().toISOString(),
    };

    // In a real application, you would send this to a server or save to localStorage
    // For now, we'll just log it to the console
    console.log("Exam Result:", resultData);

    // Note: In a real React app, you can't directly write to a file from the browser
    // This would typically be sent to a backend API
    // For demonstration, we'll simulate saving by storing in localStorage
    const existingResults = JSON.parse(
      localStorage.getItem("quizResults") || "[]"
    );
    existingResults.push(resultData);
    localStorage.setItem("quizResults", JSON.stringify(existingResults));
  }

  startQuiz() {
    if (this.state.participantName.trim() === "") {
      alert("Please enter your name to start the quiz!");
      return;
    }

    if (this.state.participantClass.trim() === "") {
      alert("Please enter your class to start the quiz!");
      return;
    }

    if (this.state.participantSection.trim() === "") {
      alert("Please enter your section to start the quiz!");
      return;
    }

    if (this.state.participantRoll.trim() === "") {
      alert("Please enter your roll number to start the quiz!");
      return;
    }

    this.setState(
      {
        isQuizStarted: true,
        isTimerRunning: true,
        timeLeft: 120,
        isQuizEnded: false,
      },
      () => {
        // Start the countdown timer
        const timerInterval = setInterval(() => {
          this.setState((prevState) => {
            if (prevState.timeLeft <= 1) {
              clearInterval(timerInterval);
              // Auto-submit when time is up
              this.saveResults();
              return {
                timeLeft: 0,
                isTimerRunning: false,
                isQuizEnded: true,
              };
            }
            return {
              timeLeft: prevState.timeLeft - 1,
            };
          });
        }, 1000);

        this.setState({ timerInterval });
      }
    );
  }

  resetQuiz() {
    // Clear the timer interval
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
    }

    this.setState({
      noOfQuesAttained: 0,
      noOfQuesCorrect: 0,
      questionsAnswered: new Set(),
      timeLeft: 120,
      isTimerRunning: false,
      isQuizStarted: false,
      isQuizEnded: false,
      timerInterval: null,
    });
  }

  componentDidMount() {
    this.getQuestions();
  }

  componentWillUnmount() {
    // Clean up the timer interval
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
    }
  }

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  }

  render() {
    const {
      participantName,
      participantClass,
      participantSection,
      participantRoll,
      quizSession,
      noOfQuesAttained,
      noOfQuesCorrect,
      timeLeft,
      isQuizStarted,
      isQuizEnded,
    } = this.state;

    return (
      <div className="container mt-4">
        <h1 className="mb-4 text-center">Manikchak High Madrasah(H.S) </h1>
        <h2 className="text-center">Quiz Contest</h2>

        {/* Participant Info and Timer Section */}
        <div className="card mb-4">
          <div className="card-body">
            {!isQuizStarted ? (
              <div className="text-center">
                {/* Place student info fields in a row for larger screens */}
                <div className="row justify-content-center">
                  <div className="col-md-3 mb-3">
                    <label htmlFor="participantName" className="form-label">
                      <h4>Name:</h4>
                    </label>
                    <input
                      type="text"
                      id="participantName"
                      className="form-control form-control-lg text-center"
                      value={participantName}
                      onChange={(e) =>
                        this.setState({ participantName: e.target.value })
                      }
                      placeholder="Your Name"
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label htmlFor="participantClass" className="form-label">
                      <h4>Class:</h4>
                    </label>
                    <input
                      type="text"
                      id="participantClass"
                      className="form-control form-control-lg text-center"
                      value={participantClass}
                      onChange={(e) =>
                        this.setState({ participantClass: e.target.value })
                      }
                      placeholder="Your Class"
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label htmlFor="participantSection" className="form-label">
                      <h4>Section:</h4>
                    </label>
                    <input
                      type="text"
                      id="participantSection"
                      className="form-control form-control-lg text-center"
                      value={participantSection}
                      onChange={(e) =>
                        this.setState({ participantSection: e.target.value })
                      }
                      placeholder="Your Section"
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label htmlFor="participantRoll" className="form-label">
                      <h4>Roll Number:</h4>
                    </label>
                    <input
                      type="text"
                      id="participantRoll"
                      className="form-control form-control-lg text-center"
                      value={participantRoll}
                      onChange={(e) =>
                        this.setState({ participantRoll: e.target.value })
                      }
                      placeholder="Your Roll No."
                    />
                  </div>
                </div>

                <button
                  className="btn btn-success btn-lg mt-3"
                  onClick={this.startQuiz}
                  disabled={
                    participantName.trim() === "" ||
                    participantClass.trim() === "" ||
                    participantSection.trim() === "" ||
                    participantRoll.trim() === ""
                  }
                >
                  Start Quiz (2 Minutes)
                </button>
                <p className="mt-3 text-muted">
                  You will have 2 minutes to complete {quizSession.length}{" "}
                  questions.
                </p>
              </div>
            ) : (
              <div>
                <div className="row">
                  <div className="col-md-4">
                    <h4>
                      Participant:{" "}
                      <span className="text-primary">{participantName}</span>
                    </h4>
                    <p>
                      Class: {participantClass} | Section: {participantSection}{" "}
                      | Roll: {participantRoll}
                    </p>
                  </div>
                  <div className="col-md-4 text-center">
                    <div
                      className={`display-4 ${
                        timeLeft <= 30 ? "text-danger" : "text-success"
                      }`}
                    >
                      {this.formatTime(timeLeft)}
                    </div>
                    <h6>Time Remaining</h6>
                  </div>
                  <div className="col-md-4 text-end">
                    {/* Submit Button */}
                    <button
                      className="btn btn-primary mr-2"
                      onClick={this.handleSubmit}
                      disabled={isQuizEnded}
                    >
                      Submit Exam
                    </button>
                    <button
                      className="btn btn-warning"
                      onClick={this.resetQuiz}
                    >
                      Restart Quiz
                    </button>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <h5>
                      Questions Answered: {noOfQuesAttained}/
                      {quizSession.length}
                    </h5>
                  </div>
                  <div className="col-md-6">
                    <h5>
                      Score: {noOfQuesCorrect}/{quizSession.length}
                    </h5>
                  </div>
                </div>

                {isQuizEnded && (
                  <div className="alert alert-info mt-3">
                    <h4>Quiz Completed!</h4>
                    <strong>
                      Final Score: {noOfQuesCorrect}/{quizSession.length}
                    </strong>
                    <p>Your results have been saved.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Questions Section - Only show when quiz is started */}
        {isQuizStarted && quizSession.length > 0 && (
          <div className="questions-section">
            {quizSession.map(
              ({ id, question, answers, correctIndex }, index) => (
                <QuestionBox
                  key={id}
                  question={question}
                  answers={answers}
                  correctIndex={correctIndex}
                  timeUp={isQuizEnded}
                  questionNumber={index + 1}
                  updateStatus={(isCorrect) => this.updateStatus(isCorrect, id)}
                />
              )
            )}
          </div>
        )}

        {/* Show message when all questions are answered before time runs out */}
        {isQuizStarted &&
          noOfQuesAttained === quizSession.length &&
          quizSession.length > 0 &&
          !isQuizEnded && (
            <div className="alert alert-success mt-3">
              <h4>🎉 Congratulations {participantName}!</h4>
              <p>You completed all questions before time ran out!</p>
              <strong>
                Final Score: {noOfQuesCorrect}/{quizSession.length}
              </strong>
              <div className="mt-2">
                <button className="btn btn-primary" onClick={this.handleSubmit}>
                  Submit Exam
                </button>
              </div>
            </div>
          )}

        {/* Instructions */}
        {!isQuizStarted && (
          <div className="card mt-4">
            <div className="card-header">
              <h5>Quiz Instructions:</h5>
            </div>
            <div className="card-body">
              <ul>
                <li>
                  Enter your name, section, and roll number above to start the
                  quiz
                </li>
                <li>
                  You will have 2 minutes (120 seconds) to complete all
                  questions
                </li>
                <li>Once you select an answer, you cannot change it</li>
                <li>
                  Correct answers will be shown in green, incorrect in red
                </li>
                <li>
                  After time expires, you will see the correct answers for
                  unanswered questions
                </li>
                <li>
                  You can restart the quiz at any time using the "Restart Quiz"
                  button
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TestComponent;
